<template>
	<div class="">
		<!--header-->
		<app-header :headerTitle="successMessage ? 'سفارش شما با موفقیت ثبت شد' : 'روش پرداخت را انتخاب کنید'"></app-header>

		<!--loading-->
		<div class="loading text-center px-3" v-if="loading">
			<div class="alert alert-blue d-inline-block py-2 px-3">
				<i class="fa fa-refresh fa-spin ml-1 align-middle"></i> در حال بارگذاری ...
			</div>
		</div>

		<div v-else>
			<div class="success mt-3 px-3" v-if="successMessage">
				<div class="alert alert-success p-2" v-html="successMessage"></div>
			</div>
			<div class="payment px-3" v-else>
				<div class="payment-types my-4">
					<div class="card mb-4" v-if="onlineStatus">
						<form @submit.prevent @submit="submitOnlinePayment(onlineGateway)">
							<div class="card-body bg-light">
								<h5 class="card-title">
									پرداخت آنلاین
								</h5>
								<select class="form-control" v-model="onlineGateway" :disabled="progress">
									<option value="" v-if="!onlineGateway">---</option>
									<option :key="onlineGateway.id" v-for="onlineGateway in onlineGateways" :value="onlineGateway.id">{{ onlineGateway.title }}</option>
								</select>
								<div class="form-error mt-2" v-if="$v.onlineGateway.$error">
									لطفا درگاه پرداخت را انتخاب کنید.
								</div>
								<div class="mt-3">
									<button type="submit" class="btn btn-block btn-green" :disabled="progress">
										{{ progress ? 'کمی صبر کنید ...': 'پرداخت آنلاین' }}
									</button>
								</div>
							</div>
						</form>
					</div>
					<div class="card mb-4" v-if="bankStatus">
						<div class="card-body bg-light">
							<h5 class="card-title">
								واریز به حساب
							</h5>
							<select class="form-control" v-model="gatewaysModel" :disabled="progress">
								<option value="" v-if="!onlineGateway">---</option>
								<option :key="gateway.id" v-for="gateway in gateways" :value="gateway.id">{{ gateway.title }}</option>
							</select>
							<p class="card-text pt-3 mb-0" :key="gateway.id" v-for="gateway in gateways" v-show="gatewaysModel == gateway.id">
								<!-- <strong>{{ gateway.title }}</strong><br> -->
								شماره حساب: <strong>{{ gateway.account }}</strong><br>
								شماره کارت: <strong>{{ gateway.pan }}</strong><br>
								شبا: <strong>{{ gateway.iban }}</strong><br>
								دارنده حساب: <strong>{{ gateway.owner }}</strong><br>
								مبلغ قابل پرداخت: <strong class="text-primary">{{ totalPrice }} تومان</strong>
							</p>
							<hr>
							<form @submit.prevent @submit="submitTrackingCode(gatewaysModel)">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" placeholder="مانند: 12345">
											کد پیگیری
										</span>
									</div>
									<input class="form-control"
										v-model="trackingCode"
										:disabled="progress"
										:class="{'error': $v.trackingCode.$error}">
								</div>
								<div class="form-error mt-2" v-if="$v.trackingCode.$error">
									اگر از این روش برای پرداخت استفاده می‌کنید، لطفا کد پیگیری پرداخت را وارد کنید.
								</div>
								<button type="submit" class="btn btn-block btn-green mt-3" :disabled="progress">
									{{ progress ? 'کمی صبر کنید ...': 'ثبت فیش واریزی' }}
								</button>
							</form>
						</div>
					</div>
					<div class="card mb-4" v-if="deliveryStatus">
						<div class="card-body bg-light">
							<h5 class="card-title">
								پرداخت در محل
							</h5>
							<p class="card-text mb-0 text-muted small">
								مبلغ سفارش را به مامور پست پرداخت خواهید کرد. این روش ارسال شامل <b class="text-red">کارمزد</b> خواهد شد.
							</p>
							<button type="button" class="btn btn-block btn-green mt-3"
								:disabled="progress"
								@click="submitCashonDelivery()">
								{{ progress ? 'کمی صبر کنید ...': 'ثبت درخواست' }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "../components/Header.vue"
	import axios from 'axios'
	import { required } from 'vuelidate/lib/validators'
	export default {
		components: {
			appHeader: Header
		},
		data() {
			return {
				loading: true,
				progress: null,
				token: this.$route.query.token,
				// gateways
				gateways: null,
				gatewaysModel: null,
				onlineGateway: null,
				onlineGateways: [],
				redirectOnline: null,
				trackingCode: "",
				// payments status
				paymentStatus: false,
				bankStatus: false,
				onlineStatus: false,
				deliveryStatus: false,

				successMessage: null,
				details: {},
				totalPrice: "",
				apiErrors: [],
				submitStatus: null
			}
		},
		validations: {
			trackingCode: {
				required
			},
			onlineGateway: {
				required
			}
		},
		methods: {
			submitOnlinePayment(gatewayID) {

				this.$v.onlineGateway.$touch()
				if (this.$v.onlineGateway.$invalid) {
					this.submitStatus = 'ERROR'
				} else {
					this.submitStatus = 'OK'
				}

				if(this.submitStatus == 'OK') {
					// progress
					this.progress = true

					axios({
						method: "post",
						url: "/site/api/v1/cart/payment/online?token="+this.token,
						data: {
							gateway_id: gatewayID,
						}
					})
					.then(response => {
						this.successMessage = response.data.description
						this.redirectOnline = response.data.redirect
						setTimeout(() => {
							window.location.href = window.location.protocol+"//"+window.location.hostname+this.redirectOnline
						}, 2000)
						// progress
						setTimeout(() => { this.progress = false }, 500)
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
						// progress
						setTimeout(() => { this.progress = false }, 500)
					});
				}
			},
			submitTrackingCode(gatewayID) {

				this.$v.trackingCode.$touch()
				if (this.$v.trackingCode.$invalid) {
					this.submitStatus = 'ERROR'
				} else {
					this.submitStatus = 'OK'
				}

				if(this.submitStatus == 'OK') {
					// progress
					this.progress = true

					axios({
						method: "post",
						url: "/site/api/v1/cart/payment?token="+this.token,
						data: {
							gateway_id: gatewayID,
							reference_id: this.trackingCode
						}
					})
					.then((response) => {
						this.successMessage = response.data.description
						this.successMessage = "از سفارش شما بسیار سپاس‌گزاریم. همکاران ما به‌زودی سفارش شما را بررسی خواهند کرد. <br><br> کد پیگیری: <strong>"+this.details.id+"</strong>"
						// progress
						setTimeout(() => { this.progress = false }, 500)
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
						// progress
						setTimeout(() => { this.progress = false }, 500)
					});
				}
			},
			submitCashonDelivery() {
				// progress
				this.progress = true

				axios({
					method: "post",
					url: "/site/api/v1/cart/payment/cod?token="+this.token,
				})
				.then(response => {
					this.successMessage = response.data.description
					// progress
					setTimeout(() => { this.progress = false }, 500)
				})
				.catch((err) => {
					this.apiErrors.push(err.response)
					// progress
					setTimeout(() => { this.progress = false }, 500)
				});
			}
		},
		created () {
			// get order details
			axios({
				method: "get",
				url: "/site/api/v1/cart/details?token="+this.token,
			})
			.then(response => {
				this.details = response.data.details
				this.totalPrice = this.details.price

				// payments status
				this.paymentStatus = this.details.payment.enabled
				if(!this.paymentStatus) {
					this.successMessage = "سفارش شما با موفقیت ثبت شد، به زودی با شما تماس خواهیم گرفت."
				}
				this.bankStatus = this.details.payment.bank
				this.onlineStatus = this.details.payment.online
				this.deliveryStatus = this.details.payment.cash_on_delivery

				// get gateways
			axios({
				method: "get",
				url: "/site/api/v1/cart/gateways"
			})
			.then(response => {
				this.gateways = response.data.gateways
				if(this.gateways.length) {
					this.gatewaysModel = this.gateways[0].id
				}
			})
			.catch((err) => {
				this.apiErrors.push(err.response)
			});

			// get oniline gateways
			axios({
				method: "get",
				url: `/site/api/v1/cart/gateways/online?amount=${this.totalPrice}`
			})
			.then(response => {
				this.onlineGateways = response.data.gateways
				if(this.onlineGateways.length) {
					this.onlineGateway = this.onlineGateways[0].id
				}
			})
			.catch((err) => {
				this.apiErrors.push(err.response)
			});

				// loading
				setTimeout(() => { this.loading = false }, 500)
			})
			.catch((err) => {
				this.apiErrors.push(err.response)
				// loading
				setTimeout(() => { this.loading = false }, 500)
			});
		},
	}
</script>

<style>
.payment { padding-bottom: 10px; padding-top: 66px; }
.success { padding-bottom: 100px; padding-top: 70px; }
</style>
